import { ReactElement } from "react";

import { numberWithCommas } from "../../../common/utils";
import { useAmplitudeTrack } from "../../../common/useAmplitudeTrack";

import { pushPopup } from "../../../providers/popups";
import useReservationsContext from "../../../providers/reservations";

import VFlex from "../../../layouts/VFlex";
import HFlex from "../../../layouts/HFlex";
import Text from "../../../layouts/Text";
import Image from "../../../layouts/Image";
import ResizeTable from "../../../layouts/ResizeTable";
import Button from "../../../layouts/ButtonV2";
import LoadingView from "../../../layouts/LoadingView";

import ReservationListFilter, {
  ReservationListType,
} from "../../../components/Reservation/ReservationListFilter";
import Pagination from "../../../components/Pagination";
import { PopupKind } from "../../../popup/Popup";
import NewReservation from "../Calendar/NewReservtaion";
import ReservationDetail from "../Calendar/ReservationDetail";

import _ from "lodash";

const ITEMS_PER_PAGE = 10;

function ReservationList({
  setSelectedSubpage,
}: {
  setSelectedSubpage: (component?: ReactElement) => void;
}) {
  const {} = useAmplitudeTrack();

  const {
    totalCount,
    reservations,
    page,
    setPage,
    searchText,
    setSearchText,
    statusFilter,
    setStatusFilters,
    setStatusFiltersId,
    sortFilters,
    setSortFilters,
    startDateFilter,
    setEndDateFilter,
    endDateFilter,
    setStartDateFilter,
    fetchCurrentPage,
    isLoading,
  } = useReservationsContext();

  return (
    <VFlex ovf-h height={"100%"}>
      <HFlex p-16-tb p-24-rl j-b bd-b-t5>
        <HFlex g-8 a-c>
          <Image
            size={24}
            clickable
            src={`/icons/icon_back.png`}
            onClick={() => setSelectedSubpage(undefined)}
          />
          <Text t-22-600-s8>예약</Text>
        </HFlex>
        <Button
          type="filled"
          icon={"/icons/icon_add.png"}
          iconSize={18}
          onClick={() => {
            pushPopup({
              kind: PopupKind.Popup,
              element: NewReservation,
              dimClick: "none",
              props: { fetchCurrentPage },
            });
          }}
        >
          새로운 일정 등록
        </Button>
      </HFlex>

      <ReservationListFilter
        type={ReservationListType.basic}
        keyword={searchText}
        setKeyword={setSearchText}
        statusList={statusFilter}
        setStatusList={setStatusFilters}
        setStatusFiltersId={setStatusFiltersId}
        sortsFilters={sortFilters}
        setSortsFilters={setSortFilters}
        startDateFilter={startDateFilter}
        setStartDateFilter={setStartDateFilter}
        endDateFilter={endDateFilter}
        setEndDateFilter={setEndDateFilter}
      />

      <HFlex p-24-rl j-b a-c>
        <Text t-16-600-s8 p-8-tb>
          전체 ({numberWithCommas(totalCount)})
        </Text>
        {/* <Image src="/icons/icon_add_circle_outline_s6.svg" size={20} p-10 /> */}
      </HFlex>

      <LoadingView loading={isLoading} f-1>
        {reservations.length === 0 ? (
          <VFlex
            a-c
            j-c
            bd-t3
            bdr-16
            g-8
            style={{
              padding: "100px 0",
              margin: "0 24px",
            }}
          >
            <Image size={24} src={`/icons/icon_noti.svg`} />
            <Text t-16-s2>내역이 존재하지 않습니다.</Text>
          </VFlex>
        ) : (
          <VFlex f-1 a-st ovf-a p-24-rl>
            <ResizeTable
              data={reservations}
              onClick={(data) => {
                pushPopup({
                  key: "resDetail",
                  kind: PopupKind.Popup,
                  element: ReservationDetail,
                  props: {
                    reservationId: data.id,
                    petId: data.pet.id,
                    schedule: data,
                    fetchCurrentPage,
                  },
                  dimClick: "none",
                });
              }}
            />
          </VFlex>
        )}
      </LoadingView>

      {reservations.length !== 0 && (
        <VFlex p-16-tb>
          <Pagination
            page={page}
            pageCount={totalCount / ITEMS_PER_PAGE}
            onPageChange={(n) => setPage(n)}
          />
        </VFlex>
      )}
    </VFlex>
  );
}

export default ReservationList;
